import React from "react";
import { Icon } from "../../Icon/Icon";
import "./Button.css";

/**
 * Button
 *
 * @param {object} props
 * @prop {ReactNode} props.children
 * @prop {string} [props.type] The humble button type...
 * @prop {?string=} props.buttonStyle
 * @prop {function} props.click
 * @prop {boolean=} props.disabled
 * @prop {boolean=} props.active
 * @prop {object=} props.style
 * @return {*}
 */
export const Button = ({
  children,
  type,
  buttonStyle = null,
  click = () => {},
  disabled = false,
  active = false,
  style = {},
}) => {
  const staticStyles = ["Button"];
  if (buttonStyle) {
    staticStyles.push(buttonStyle);
  }
  if (active) {
    staticStyles.push(buttonStyle + "--active");
  }

  const combinedStyles = staticStyles.join(" ");

  return (
    <button
      data-testid="button"
      type={type}
      className={combinedStyles}
      onClick={click}
      disabled={disabled}
      style={style}
    >
      {children}
    </button>
  );
};

export const ButtonLoading = () => (
  <div className="ButtonLoading">
    <Icon name="iconSpinner" width={18} />
  </div>
);
